import React from 'react';
import { Icon, ContextMenu } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { SwitchTicketOffice } from './switch-ticket-office.js';
import { OpenCreationModal } from '../../../pages/ticket_offices/ticketOfficesTemplate';
import TicketOffice from '../../../models/ticket_office';

export default function TicketOfficeContextMenu({ organization, ticket_office, syncTicketOffice }) {
    const { t } = useTranslation();
    const [allTicketsOffices] = TicketOffice.useApiModel({
        organizationId: organization.id,

        query: {
            deleted: '0'
        }
    });

    return (
        <SwitchTicketOffice organization={organization} ticket_office_id={ticket_office.id}>
            <ContextMenu
                catchphrase={
                    <span className="event-catchphrase">
                        <Icon name="tickets" />
                        {t('ticket.ticket_offices.context_menu.catchphrase', { id: ticket_office.id })}
                    </span>
                }
                cta={<OpenCreationModal organization={organization} ticketsOffices={allTicketsOffices} syncTicketOffices={syncTicketOffice} />}
                title={ticket_office.name}
                url={window.weezConfig.ticket_office}
                urlTooltipProps={{ visible: false }}
            />
        </SwitchTicketOffice>
    );
}
